exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes renderColor-1bb9e798{0%{background-color:#f8f9fc}25%{background-color:#ccc}50%{background-color:silver}75%{background-color:#ccc}to{background-color:#f8f9fc}}", ""]);

// exports
